import styled from 'styled-components';

import MenuSectionHeading from 'components/menu-section-heading';

export const ModalContent = styled.div`
  width: 100%;
  background-color: ${Styles.color.white};
  height: 100%;
`;

export const ModalHeading = styled(MenuSectionHeading)`
  margin: 0.5rem auto 2rem;
  font-size: 1.25rem;
  text-align: center;
`;

export const ModalTop = styled.div`
  padding: 1rem 2rem 0;
  z-index: ${Styles.zIndex.max};
`;

export const ModalBottom = styled.div`
  ${Styles.desktop`
    padding: 0 2rem;
  `}
`;
